module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/babb949cceaed30ec7f6c1c0b891e1fd.png";